module.exports = __webpack_public_path__ + "static/media/autoimage.ca5f1eca.jpg";